import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DistrictSelector } from '@components';

export const DistrictSearchInput: React.FC = () => {
	const navigate = useNavigate();
	const navigatationHandler = (val: string) => {
		navigate(val);
	};

	return (
		<div className="w-full  mx-auto  text-center pt-6">
			<h1 className="text-2xl font-bold-600 text-[24px]   mb-4">
				District Dashboard
			</h1>

			<div className="mx-auto  mt-16 w-full md:w-[45%]">
				<div className="mb-6 mt-6 mx-5">
					<p className="block font-medium   mb-6">
						View data about a district or zip code:
					</p>
					<div className=" grid justify-center w-full">
						<DistrictSelector />
					</div>
				</div>

				{/* Custom Search */}
				<div className="mb-6 mt-12 mx-5">
					<p className="block font-medium   mb-6">
						<span className="font-medium  ">
							You can also{' '}
							<span
								className="text-link"
								onClick={navigatationHandler.bind(this, '/lookup')}
							>
								find information about a building
							</span>{' '}
							or{' '}
							<span
								onClick={navigatationHandler.bind(this, '/search')}
								className="text-link"
							>
								create a Custom Search
							</span>
						</span>
					</p>
				</div>
			</div>
		</div>
	);
};
